import {
  borderRadius,
  Icon,
  typographyV2,
  WithNAFallback,
} from '@toggle/design-system';
import styled from 'styled-components';

export const Root = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
`;

export const FlexRowWrapper = styled.div`
  display: flex;
  align-items: center;
  flex-direction: row;
  gap: 4px;
`;

export const CompanyNameContainer = styled.div`
  display: flex;
  flex-direction: column;
  overflow: hidden;
  margin-left: 8px;
  ${typographyV2.bodySm};
`;

export const Tag = styled.p`
  ${typographyV2.bodySm}
  color: var(--text-soft);
  text-transform: uppercase;
  align-items: center;
`;

export const IconContainer = styled.div`
  position: absolute;
  top: -4px;
  right: -4px;
`;

export const IconsContainer = styled.div`
  position: relative;
`;

export const StyledIcon = styled(Icon)`
  background-color: var(--background-soft);
  ${borderRadius.rFull};
  width: 16px;
  height: 16px;
`;

export const StyledTextNA = styled(WithNAFallback.Styled.Text)`
  display: flex;
  justify-content: center;
`;
